import React from "react";
import InternalVendorProfileContent from "./InternalVendorProfileContent";

const InternalVendorInfoDrawer = ({
  open,
  vendor,
  onClose,
  onViewRfq,
  onViewOrderValue,
  widthClassName = "max-w-[620px]",
}) => (
  <div className={`fixed inset-0 z-[9999] flex justify-end bg-slate-900/35 backdrop-blur-[2px] transition-opacity duration-300 ${open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"}`} onClick={onClose}>
<aside
  className={`relative h-full w-full ${widthClassName} overflow-hidden bg-white shadow-2xl ring-1 ring-black/5 transition-transform duration-500 ${
    open ? "translate-x-0" : "translate-x-full"
  }`}
  onClick={(event) => event.stopPropagation()}
>      <button type="button" onClick={onClose} aria-label="Close vendor profile" className="absolute right-4 top-4 z-20 flex h-8 w-8 items-center justify-center rounded-full border border-[#E5E1D8] bg-white/90 text-[#4B5563] shadow-sm transition hover:bg-[#FFF0E4] hover:text-[#111827]">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4"><path d="m6 6 12 12M18 6 6 18" /></svg>
      </button>
      <div className="h-full overflow-y-auto">
        <InternalVendorProfileContent
          vendor={vendor}
          onViewRfq={onViewRfq}
          onViewOrderValue={onViewOrderValue}
        />
      </div>
    </aside>
  </div>
);

export default InternalVendorInfoDrawer;
